import { Box } from "@mui/system";
import { useEffect } from "react";
import { useState } from "react";
import MoreProgramSlide from "./MoreProgramSlide";
import axios from "axios";
import { configState } from "../lib/State";
import ModalComp from "./ModalComp";

export default function MoreProgramResume({ children }) {
  const [program, setProgram] = useState([]);
  useEffect(async () => {
    const result = await axios.post(
      configState.api + "/gympass/more_program",
      {}
    );
    if (result.status === 200) {
      const datas = result.data;
      let editResult = [];
      datas.forEach((data) => {
        const cut = data.value.split("|");
        editResult.push({
          id: data.id,
          engName: cut[0],
          korName: cut[1],
          creator: cut[2],
          value: cut[3],
          icon: cut[4],
          creatorImg: cut[5],
        });
      });
      setProgram(editResult);
    }
  }, []);

  return (
    <ModalComp
      fullScreen
      button={<div>{children}</div>}
      title="운동프로그램"
      divider
    >
      <Box style={{ display: "flex", flexDirection: "column" }}>
        <MoreProgramSlide data={program} col="3" row="3" />
      </Box>
    </ModalComp>
  );
}
